import { lazy } from 'react'

export const Motivation = lazy(() => import('./v1/Motivation'))
export const MotivationV2 = lazy(() => import('./v2/MotivationV2'))
export const MotivationV3 = lazy(() => import('./v3/MotivationV3'))
